import { findFollowUpChecked } from "./followUps";

const RANKED_CAP = 10;

/**
 * @param {Element} section
 * @param {Element} input
 * @returns {object}
 */
function describeMainAnswer(section, input) {
  const answerIndex = parseInt(input.getAttribute("data-answer-index"), 10);
  const label = input.closest("label");
  const titleEl = label ? label.querySelector(".question-answer-title") : null;
  const answerTitle = titleEl ? String(titleEl.textContent || "").trim() : "";
  const followUpInput = findFollowUpChecked(section, answerIndex);
  let followUpIndex = null;
  let followUpTitle = null;

  if (followUpInput) {
    followUpIndex = parseInt(
      followUpInput.getAttribute("data-follow-up-index"),
      10
    );
    const fuLabel = followUpInput.closest("label");
    const fuTitleEl = fuLabel
      ? fuLabel.querySelector(".question-answer-title")
      : null;

    followUpTitle = fuTitleEl ? String(fuTitleEl.textContent || "").trim() : "";
  }

  return {
    // eslint-disable-next-line camelcase
    answer_index: Number.isFinite(answerIndex) ? answerIndex : -1,
    // eslint-disable-next-line camelcase
    answer_title: answerTitle,
    // eslint-disable-next-line camelcase
    follow_up_index: Number.isFinite(followUpIndex) ? followUpIndex : null,
    // eslint-disable-next-line camelcase
    follow_up_title: followUpTitle
  };
}

/**
 * @param {object|null|undefined} cfg ignitedProductSelector
 * @returns {object}
 */
export function getProductSelectorAnalyticsContext(cfg) {
  const context = {};

  if (!cfg) {
    return context;
  }

  if (cfg.termId != null) {
    // eslint-disable-next-line camelcase
    context.term_id = cfg.termId;
  }

  if (typeof cfg.categoryName === "string" && cfg.categoryName) {
    // eslint-disable-next-line camelcase
    context.category_name = cfg.categoryName;
  }

  if (typeof cfg.categorySlug === "string" && cfg.categorySlug) {
    // eslint-disable-next-line camelcase
    context.category_slug = cfg.categorySlug;
  }

  if (typeof cfg.locale === "string" && cfg.locale) {
    context.locale = cfg.locale;
  }

  return context;
}

/**
 * @param {object|null|undefined} cfg
 * @param {string} eventName
 * @param {object} [payload]
 */
export function pushProductSelectorEvent(cfg, eventName, payload) {
  if (typeof eventName !== "string" || !eventName) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  const data = Object.assign(
    {},
    getProductSelectorAnalyticsContext(cfg),
    payload && typeof payload === "object" ? payload : {},
    { event: eventName }
  );

  window.dataLayer.push(data);
}

/**
 * @param {Element} section
 * @returns {{ question_index: number, question_title: string, question_type: string, answers: object[] }}
 */
export function buildStepCompletePayload(section) {
  const questionIndex = parseInt(
    section.getAttribute("data-question-index"),
    10
  );
  const questionType = section.getAttribute("data-question-type") || "";
  const titleEl = section.querySelector(
    ".product-selector-page__question-title"
  );
  const questionTitle = titleEl ? String(titleEl.textContent || "").trim() : "";
  const answers = [];

  if (questionType === "single-choice") {
    const main = section.querySelector("input[data-ps-main]:checked");

    if (main) {
      answers.push(describeMainAnswer(section, main));
    }
  } else if (questionType === "multiple-choice") {
    const mains = section.querySelectorAll("input[data-ps-main]:checked");

    for (let i = 0; i < mains.length; i++) {
      answers.push(describeMainAnswer(section, mains[i]));
    }
  }

  return {
    // eslint-disable-next-line camelcase
    question_index: Number.isFinite(questionIndex) ? questionIndex : -1,
    // eslint-disable-next-line camelcase
    question_title: questionTitle,
    // eslint-disable-next-line camelcase
    question_type: questionType,
    answers: answers
  };
}

/**
 * @param {object} data AJAX success data.data
 * @param {object[]} selections
 * @returns {object}
 */
export function buildResultsEventPayload(data, selections) {
  const winnerId = data && data.winner != null ? Number(data.winner) : null;
  const runnerUpIds =
    data && Array.isArray(data.runner_up_ids)
      ? data.runner_up_ids.map(Number)
      : [];
  const rankedRaw =
    data && Array.isArray(data.ranked) ? data.ranked.slice(0, RANKED_CAP) : [];
  const ranked = rankedRaw
    .map(function(row) {
      if (!row || typeof row !== "object") {
        return null;
      }

      return {
        // eslint-disable-next-line camelcase
        product_id: Number(row.product_id) || 0,
        title: typeof row.title === "string" ? row.title : "",
        score: Number(row.score) || 0
      };
    })
    .filter(Boolean);
  let winnerTitle = "";

  for (let i = 0; i < ranked.length; i++) {
    if (ranked[i].product_id === winnerId) {
      winnerTitle = ranked[i].title;
      break;
    }
  }

  return {
    selections: selections,
    // eslint-disable-next-line camelcase
    winner_id: winnerId,
    // eslint-disable-next-line camelcase
    winner_title: winnerTitle,
    // eslint-disable-next-line camelcase
    runner_up_ids: runnerUpIds,
    ranked: ranked
  };
}
